<template>
<div class="logistic-tab">
	<button @click="goToLogistic('land-logistic')" class="button primary">
		By Land
	</button>
	<button @click="goToLogistic('sea-logistic')" class="button primary">
		By Sea
	</button>
	<button @click="goToLogistic('air-logistic')" class="button primary">
		By Air
	</button>
</div>
</template>

<script>
export default {
	methods: {
		goToLogistic(name) {
			this.$router.push({
				name,
				query: {
					...this.$route.query,
					opportunityId: this.$route.params.opportunityId
				}
			})
		}
	}
}
</script>

<style lang="scss">
.logistic-tab {
	display: inline-table;
	margin: 12px 0px 12px !important;

	.button {
		font-weight: 400;
		width: auto;
		font-size: 14px;
		text-transform: capitalize;
		padding: 4px 15px;
		float: left;
		margin: 0px 9px 0px 0px;
	}
}
</style>
